import React, { useState, useEffect } from 'react';
import './TemplatePage.css';
import Navbar from '../Homepage/Navbar/Navbar';
import Footer from '../Homepage/Footer/Footer';
import { Link } from "react-router-dom"

const TemplatePage = ({ data }) => {
  const {
    departmentName,
    bannerImage,
    about,
    brochure,
    hod,
    bos,
    faculty,
    courses,
    Infrastructure
  } = data;

  const sections = [
    { id: 'about', label: 'About', show: !!about },
    // { id: 'brochure', label: 'Brochure', show: !!brochure },
    { id: 'hod', label: 'HOD', show: !!hod },
    { id: 'bos', label: 'BOS', show: !!bos },
    { id: 'faculty', label: 'Faculty', show: !!faculty },
    { id: 'courses', label: 'Courses', show: !!courses },
    { id: 'Infrastructure', label: 'Infrastructure', show: !!Infrastructure }
  ].filter(section => section.show);

  const [activeSection, setActiveSection] = useState(sections[0]?.id || 'about');
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const handleSectionClick = (sectionId) => {
    setActiveSection(sectionId);
    setIsMobileSidebarOpen(false);
  };

  return (
    <>
      <Navbar />
      <div className="rukdept-page-container">
        {/* Banner Image */}
        {bannerImage && (
          <div className="rukdept-banner">
            <img src={bannerImage} alt={departmentName} className="rukdept-banner-image" />
            <div className="rukdept-banner-overlay">
              <h1 className="rukdept-banner-title">{departmentName}</h1>
            </div>
          </div>
        )}

        <div className="rukdept-content-wrapper">
          {/* Mobile Sidebar Toggle */}
          <button
            className="rukdept-mobile-sidebar-toggle"
            onClick={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)}
          >
            {isMobileSidebarOpen ? '✕' : '☰'} Navigation
          </button>

          {/* Vertical Navigation Sidebar */}
          <aside className={`rukdept-sidebar ${isMobileSidebarOpen ? 'rukdept-sidebar-open' : ''}`}>
            <div className="rukdept-sidebar-header">
              <h3>Quick Links</h3>
            </div>
            <nav className="rukdept-sidebar-nav">
              {sections.map((section) => (
                <button
                  key={section.id}
                  className={`rukdept-nav-item ${activeSection === section.id ? 'rukdept-nav-item-active' : ''}`}
                  onClick={() => handleSectionClick(section.id)}
                >
                  {section.label}
                </button>
              ))}
            </nav>
          </aside>

          {/* Main Content Area */}
          <main className="rukdept-main-content">
            {/* About Section */}
            {about && activeSection === 'about' && (
              <section id="rukdept-section-about" className="rukdept-content-section">
                <h2 className="rukdept-section-title">{about.title}</h2>
                <div className="rukdept-section-card">
                  <p className="rukdept-section-text">{about.content}</p>
                  {about.highlights && (
                    <div className="rukdept-highlights">
                      <h3 className="rukdept-highlights-title">Key Highlights:</h3>
                      <ul className="rukdept-highlights-list">
                        {about.highlights.map((highlight, index) => (
                          <li key={index}>{highlight}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </section>
            )}

            {/* Brochure Section */}
            {brochure && activeSection === 'brochure' && (
              <section id="rukdept-section-brochure" className="rukdept-content-section">
                <h2 className="rukdept-section-title">{brochure.title}</h2>
                <div className="rukdept-section-card rukdept-brochure-card">
                  <p className="rukdept-section-text">{brochure.description}</p>
                  <a
                    href={brochure.pdfLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rukdept-download-btn"
                  >
                    Download Brochure
                  </a>
                </div>
              </section>
            )}

            {/* HOD Section */}
            {hod && activeSection === 'hod' && (
              <section id="rukdept-section-hod" className="rukdept-content-section">
                <h2 className="rukdept-section-title">Head of Department</h2>
                <div className="rukdept-section-card rukdept-hod-card">
                  <div className="rukdept-hod-header">
                    <div className="rukdept-hod-photo">
                      <img src={hod.photo} alt={hod.name} />
                    </div>
                    <div className="rukdept-hod-info">
                      <h3 className="rukdept-hod-name">{hod.name}</h3>
                      <p className="rukdept-hod-designation">{hod.designation}</p>
                      {hod.qualification && <p className="rukdept-hod-qualification">{hod.qualification}</p>}
                      {hod.specialization && <p className="rukdept-hod-specialization"><strong>Specialization:</strong> {hod.specialization}</p>}
                      <div className="rukdept-hod-contact">
                        <p><strong>Email:</strong> <a href={`mailto:${hod.email}`}>{hod.email}</a></p>
                        <p><strong>Mobile:</strong> {hod.mobile}</p>
                      </div>
                      {hod.profileLink && (
                        <Link
                            to={`/faculty/${hod.id}`}
                            className="rukdept-faculty-profile-btn"
                          >
                            View Profile
                          </Link>
                      )}
                    </div>
                  </div>
                  {hod.message && (
                    <div className="rukdept-hod-message">
                      <h4>Message from HOD</h4>
                      <p>{hod.message}</p>
                    </div>
                  )}
                </div>
              </section>
            )}

            {/* BOS Section */}
            {bos && activeSection === 'bos' && (
              <section id="rukdept-section-bos" className="rukdept-content-section">
                <h2 className="rukdept-section-title">{bos.title}</h2>
                <div className="rukdept-section-card">
                  <div className="rukdept-bos-grid">
                    {bos.members.map((member, index) => (
                      <div key={index} className="rukdept-bos-member">
                        <h4 className="rukdept-bos-member-name">{member.name}</h4>
                        <p className="rukdept-bos-member-designation">{member.designation}</p>
                        <p className="rukdept-bos-member-affiliation">{member.affiliation}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </section>
            )}

            {/* Faculty Section */}
            {faculty && activeSection === 'faculty' && (
              <section id="rukdept-section-faculty" className="rukdept-content-section">
                <h2 className="rukdept-section-title">Faculty Members</h2>
                <div className="rukdept-faculty-grid">
                  {faculty.map((member, index) => (
                    <div key={index} className="rukdept-faculty-card">
                      <div className="rukdept-faculty-photo">
                        {member.photo ? (
                          <img src={member.photo} alt={member.name} />
                        ) : (
                          <div className="rukdept-faculty-placeholder">No Photo</div>
                        )}
                      </div>
                      <div className="rukdept-faculty-info">
                        <h3 className="rukdept-faculty-name">{member.name}</h3>
                        <p className="rukdept-faculty-designation">{member.designation}</p>
                        {member.qualification && <p className="rukdept-faculty-qualification">{member.qualification}</p>}
                        {member.specialization && <p className="rukdept-faculty-specialization">{member.specialization}</p>}
                        {member.email && (
                          <p className="rukdept-faculty-email">
                            <strong>Email:</strong> <a href={`mailto:${member.email}`}>{member.email}</a>
                          </p>
                        )}
                        {member.mobile && <p className="rukdept-faculty-mobile"><strong>Mobile:</strong> {member.mobile}</p>}
                        {member.profileLink && (
                          <Link
                            to={`/faculty/${member.id}`}
                            className="rukdept-faculty-profile-btn"
                          >
                            View Profile
                          </Link>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* Courses Section */}
            {courses && activeSection === 'courses' && (
              <section id="rukdept-section-courses" className="rukdept-content-section">
                <h2 className="rukdept-section-title">Courses Offered</h2>
                <div className="rukdept-section-card">
                  {courses.undergraduate && (
                    <div className="rukdept-course-category">
                      <h3 className="rukdept-course-category-title">Undergraduate Programs</h3>
                      <div className="rukdept-courses-list">
                        {courses.undergraduate.map((course, index) => (
                          <div key={index} className="rukdept-course-item">
                            <h4>{course.name}</h4>
                            <p><strong>Duration:</strong> {course.duration}</p>
                            <p><strong>Eligibility:</strong> {course.eligibility}</p>
                            <p><strong>Intake:</strong> {course.intake}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {courses.postgraduate && (
                    <div className="rukdept-course-category">
                      <h3 className="rukdept-course-category-title">Postgraduate Programs</h3>
                      <div className="rukdept-courses-list">
                        {courses.postgraduate.map((course, index) => (
                          <div key={index} className="rukdept-course-item">
                            <h4>{course.name}</h4>
                            <p><strong>Duration:</strong> {course.duration}</p>
                            <p><strong>Eligibility:</strong> {course.eligibility}</p>
                            <p><strong>Intake:</strong> {course.intake}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {courses.research && (
                    <div className="rukdept-course-category">
                      <h3 className="rukdept-course-category-title">Research Programs</h3>
                      <div className="rukdept-courses-list">
                        {courses.research.map((course, index) => (
                          <div key={index} className="rukdept-course-item">
                            <h4>{course.name}</h4>
                            <p><strong>Duration:</strong> {course.duration}</p>
                            <p><strong>Eligibility:</strong> {course.eligibility}</p>
                            <p><strong>Research Areas:</strong> {course.areas}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </section>
            )}
            {/* //infrastructure section */}
            {Infrastructure && activeSection === "Infrastructure" && (
              <section
                id="rukdept-section-infrastructure"
                className="rukdept-content-section"
              >
                <h2 className="rukdept-section-title">Department Infrastructure</h2>

                <div className="rukdept-infra-grid">
                  {Infrastructure.map((img, index) => (
                    <div key={index} className="rukdept-infra-card">
                      <img
                        src={img}
                        alt={`Department Infrastructure ${index + 1}`}
                        loading="lazy"
                      />
                    </div>
                  ))}
                </div>
              </section>
            )}


          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TemplatePage;